import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../components/fields/Text';
import { Field } from 'redux-form';
import Button from '../../../components/elements/Button';
import { Group, Text } from '@mantine/core';
import styles from './styles.scoped.css';

export default function FormAreaManagement({
  handleClose = () => { },
  handleSubmit = () => { },
  initialValues = {},
  invalid = false,
  // isOpen = false,
  submitting = false,
}) {
  const type = initialValues.code ? 'edit' : 'add';

  const inputPropsCode = {
    label: 'Kode Wilayah',
    placeholder: 'Masukkan 6 digit kode wilayah',
    maxLength: 8,
  };
  const inputPropsName = {
    label: 'Nama Wilayah',
    placeholder: 'Masukkan nama wilayah',
  };

  const normalizeCode = (value) => {
    if (!value) return value;

    const numbers = value.replace(/\D/g, '');
    switch (numbers.length) {
      case 0:
      case 1:
      case 2:
        return numbers;
      case 3:
      case 4:
        return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
      case 5:
      case 6:
        return `${numbers.slice(0, 2)}.${numbers.slice(2, 4)}.${numbers.slice(4)}`;
      default:
        return (
          `${numbers.slice(0, 2)}.${numbers.slice(2, 4)}.` +
          `${numbers.slice(4, 6)}.${numbers.slice(6)}`
        );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Text fw={700} fz={'1.25rem'} mb={'.75rem'}>
        {type === 'edit' ? 'Ubah' : 'Tambah'} Data Wilayah
      </Text>
      <Field
        component={TextField}
        inputProps={inputPropsCode}
        isNumber
        name="code"
        normalize={normalizeCode}
      />
      <Field component={TextField} inputProps={inputPropsName} name="name" />
      <Group grow mt={'1.5rem'} spacing={'sm'}>
        <Button
          className={styles.btnSave}
          onClick={handleClose}
          style={'outlined'}
          type={'button'}
        >
          Kembali
        </Button>
        <Button
          className={styles.btnSave}
          disabled={submitting || invalid}
          style={'blue'}
          type="submit"
        >
          Simpan
        </Button>
      </Group>
    </form>
  );
}

FormAreaManagement.propTypes = {
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
  isOpen: PropTypes.bool,
  submitting: PropTypes.bool,
  type: PropTypes.string,
};
